import http from '../axios.ts'
import {sha256} from "js-sha256";

const api = {
    /**
     * 分页查询SSL证书商品
     * @param params
     */
    getAllByPage(params:Object) {
        const res = http.post('/token/getAllByPage', params);
        // console.log(res);
        return res;
    },

    /**
     * 查看详情
     * @param params
     */
    getInfoById(params:Object) {
        const res = http.post('/token/getInfoById', params);
        // console.log(res);
        return res;
    },

    /**
     * 修改
     * @param params
     */
    update(params:Object) {
        const res = http.post('/token/update', params);
        // console.log(res);
        return res;
    },

    /**
     * 新增
     * @param params
     */
    add(params:Object) {
        const res = http.post('/token/add', params);
        // console.log(res);
        return res;
    },

    /**
     * 删除
     * @param params
     */
    delete(params:Object) {
        const res = http.post('/token/delete', params);
        // console.log(res);
        return res;
    },
}


export default api
